import React from 'react'
import PropTypes from 'prop-types'

import NavHighlighter from 'components/NavHighlighter'

const Item = props => (
  <tr>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      {props.indexKey + 1}
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      {props.row.gcCountry.name}
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      {props.row.gcCommissionFeeCreator}
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>{props.row.wht}%</td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      {props.row.whtTin}%
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      {props.row.gcCommissionFeeClient}
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>{props.row.vat}%</td>
    <td style={{ border: '1px solid black' }}>
      Company Legal Name: {props.row.companyLegalName}
      <br />
      Tax Number: {props.row.taxNumber}
      <br />
      Address: {props.row.address}
    </td>
    <td style={{ border: '1px solid black' }}>
      Bank: {props.row.bank.name}
      <br />
      Account Number: {props.row.accountNumber}
      <br />
      Account Name: {props.row.accountName}
      <br />
      Swift Code: {props.row.swiftCode}
    </td>
    <td style={{ border: '1px solid black', textAlign: 'center' }}>
      <NavHighlighter
        className="btn btn-icon-only dark"
        to={`/country_taxes/${props.row.id}/edit`}
        pathname={props.pathname}
        noli
      >
        <i className="fa fa-pencil" />
      </NavHighlighter>
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    name: '',
  },
  pathname: '',
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    gcCountry: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    vat: PropTypes.number.isRequired,
    wht: PropTypes.number.isRequired,
    whtTin: PropTypes.number.isRequired,
    gcCommissionFee: PropTypes.number.isRequired,
    processingFee: PropTypes.number.isRequired,
    bank: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    companyLegalName: PropTypes.string.isRequired,
    taxNumber: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    accountName: PropTypes.string.isRequired,
    swiftCode: PropTypes.string.isRequired,
    gcCommissionFeeCreator: PropTypes.number.isRequired,
    gcCommissionFeeClient: PropTypes.number.isRequired,
  }).isRequired,
  pathname: PropTypes.string.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
